import React from 'react';
import { Eye } from 'lucide-react';

/** Read-only notice shown on every guardian screen (FAM-13). */
const ReadOnlyBanner: React.FC = () => (
  <div
    role="note"
    className="flex items-start gap-2 border-b border-sky-200 bg-sky-50 px-4 py-2 text-sm text-sky-900"
  >
    <Eye size={16} className="mt-0.5 shrink-0" aria-hidden="true" />
    <p>You&apos;re viewing a read-only record. Contact the agency to request changes.</p>
  </div>
);

export default ReadOnlyBanner;
